import { render, staticRenderFns } from "./AccountClosureRequestModal.vue?vue&type=template&id=4c624538&scoped=true&"
import script from "./AccountClosureRequestModal.vue?vue&type=script&lang=js&"
export * from "./AccountClosureRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountClosureRequestModal.vue?vue&type=style&index=0&id=4c624538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c624538",
  null
  
)

export default component.exports